import styled from "styled-components";

const BlogListStyleWrapper = styled.div`
  .blog_lists_wrapper {
    padding: 70px 0 140px;
  }

  .blog_items_row {
    row-gap: 30px;
  }
`;

export default BlogListStyleWrapper;
